import 'virtual:windi-base.css';
import 'virtual:windi-components.css';
import '/@/design/index.less';
import 'virtual:windi-utilities.css';
// Register icon sprite
import('./plugins/icons-register');
// 引入阿里矢量图标
import '@mcex/assets/iconfont/iconfont';
import '@mcex/assets/iconfont/iconfont.css';

// 引入video css
import 'video.js/dist/video-js.css';

import App from './App.vue';
import { createApp } from 'vue';
import { initAppConfigStore } from '/@/logics/initAppConfig';
import { router, setupRouter } from '/@/router';
import { setupRouterGuard } from '/@/router/guard';
import { setupStore } from '/@/store';
import { setupGlobDirectives } from '/@/directives';
import { setupI18n, i18n } from '@mcex/locale';
import { registerGlobComp } from '/@/components/registerGlobComp';
import { initFeaturesConfig } from '/@/utils/featureToggle';
import { isDevMode } from './utils/env';
import { setupKeyCloak } from './plugins/keycloak';
import { useGlobSetting } from './hooks/setting';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import isBetween from 'dayjs/plugin/isBetween';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import numeral from 'numeral';
import { setupSentry } from './plugins/sentry';
import Logan from '@mci-fe/logan-web';
import { getReportUrlByEnv } from './utils/log';

numeral.nullFormat('--');
dayjs.extend(isBetween);
dayjs.extend(relativeTime);
dayjs.extend(isSameOrAfter);

if (isDevMode()) {
  import('ant-design-vue/es/style');
}

async function bootstrap() {
  Logan.initConfig({
    reportUrl: getReportUrlByEnv(),
  });
  const app = createApp(App);

  // Configure store
  // 配置 store
  setupStore(app);

  // Initialize internal system configuration
  // 初始化内部系统配置
  initAppConfigStore();

  // 初始化特性开关
  await initFeaturesConfig();

  // Register global components
  // 注册全局组件
  registerGlobComp(app);

  // 多语言配置
  // 异步案例：语言文件可能从服务器端获取
  await setupI18n(app);

  // 指数大屏多语言配置
  import('/@/utils/translations/region').then((module) => {
    module.default(i18n, ['en', 'zh_CN']);
  });
  import('/@/utils/translations/industry').then((module) => {
    module.default(i18n, ['en', 'zh_CN']);
  });

  const { useKc } = useGlobSetting();
  useKc === 'true' && (await setupKeyCloak(app));

  // Configure routing
  // 配置路由
  setupRouter(app);

  // router-guard
  // 路由守卫
  setupRouterGuard(router);

  setupSentry(app, router);

  // Register global directive
  // 注册全局指令
  setupGlobDirectives(app);

  // Configure global error handling

  // https://next.router.vuejs.org/api/#isready
  // await router.isReady();
  app.mount('#app');
}

bootstrap();
